import { render } from "./BecomeSeller.vue?vue&type=template&id=6e795734"
import script from "./BecomeSeller.vue?vue&type=script&lang=js"
export * from "./BecomeSeller.vue?vue&type=script&lang=js"

const cssModules = {}
import style0 from "./BecomeSeller.vue?vue&type=style&index=0&id=6e795734&lang=scss&module=true"
cssModules["$style"] = style0

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules]])

export default __exports__